// extracted by mini-css-extract-plugin
export default {"nav_box":"index_nav_box_VoB32","nav":"index_nav_gzxI8","nav_piaohong":"index_nav_piaohong_JxuXz"};